import { useEffect, useState } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:5001";

export default function useSEO(page) {
  const [seo, setSEO] = useState(null);

  useEffect(() => {
    if (!page) return;
    fetch(`${API}/api/admin/seo/public/${page}`)
      .then(r => r.json())
      .then(data => setSEO(data))
      .catch(() => {});
  }, [page]);

  return seo;
}